import { useCallback, useEffect, useRef } from 'react';
export const useDebouncedCallback = (callback, delay = 150) => {
  const timeoutRef = useRef(null);
  const debouncedCallback = useCallback(() => {
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      callback();
      timeoutRef.current = null;
    }, delay);
  }, [callback, delay]);
  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return debouncedCallback;
};